export const friendList = [
  {
    user: "vanellope",
    name: "바넬로피",
    messageList: [
      { user: true, content: "안녕하세요" },
      { user: true, content: "어디야" },
      { user: true, content: "밥" },
      { user: false, content: "안녕 바넬로피" },
      { user: false, content: "뭐해 ?" },
      { user: true, content: "상빈아 밥먹자" },
      { user: false, content: "배불러  " },
      { user: false, content: "먼저 먹어" },
      { user: true, content: "ㅠㅠ" },
    ],

    content: "안녕, 난 바넬로피야!",
  },
  {
    user: "miso",
    name: "미소",
    messageList: [
      { user: true, content: "안녕하세요" },
      { user: true, content: "어디야" },
      { user: true, content: "밥" },
      { user: false, content: "안녕 미소야~~" },
      { user: false, content: "뭐해 ?" },
      { user: true, content: "상빈아 밥먹자" },
      { user: false, content: "그래 뭐먹을까 " },
      { user: false, content: "제육볶음?" },
      { user: true, content: "오늘 학식 뭐야" },
    ],
    content: "오늘 학식 뭐야",
  },
  {
    user: "jian",
    name: "지안",
    messageList: [
      { user: true, content: "안녕하세요" },
      { user: true, content: "어디야" },
      { user: true, content: "밥" },
      { user: false, content: "안녕 지안아~~" },
      { user: false, content: "뭐해 ?" },
      { user: true, content: "상빈아 네시에 밥먹기로 했잖아" },
      { user: false, content: "미안 지금 가고 있어 " },
      { user: false, content: "제육볶음?" },
      { user: true, content: "아니 언제오는거야 대체" },
    ],
    content: "아니 언제오는거야 대체",
  },
];
export default {
  friendList,
};
